import { Map, Record } from "immutable";
import { RootActions, RootState } from "common/reducers";
import { IdType } from "common/types";
import { visualizationFromJSON, VisualizationRecord } from "common/records/Visualization";
import {
  RECEIVE_VISUALIZATION,
  RECEIVE_VISUALIZATIONS,
  VisualizationActions,
} from "common/reducers/visualization.action";
import { receive } from "common/reducers/Utils";

export const VisualizationStateRecord = Record({
  byId: Map<IdType, VisualizationRecord>(),
  lastSavedById: Map<IdType, VisualizationRecord>(),
});

export const initialState = VisualizationStateRecord();
export type ValidationState = typeof initialState;

const model = "visualizations";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case RECEIVE_VISUALIZATIONS:
      action.payload.visualizations.forEach((visualization) => {
        state = reducer(state, VisualizationActions.receiveVisualization(visualization));
      });
      return state;

    case RECEIVE_VISUALIZATION:
      return receive(state, model, visualizationFromJSON(action.payload.visualization));

    default:
      return state;
  }
};
